import {
	Allow,
	IsOptional,
	IsString,
	IsDate,
	IsBoolean,
	IsNumber,
	Min,
	IsUUID,
	ValidateNested,
	ArrayMinSize,
	IsArray,
} from 'class-validator';
import { Type } from 'class-transformer';

export class CreatePopUpSectionDto {
	@IsNumber()
	@Min(0)
	order: number;

	@IsUUID()
	iconImgId: string;

	@Allow()
	iconImgVariants: any;

	@IsString()
	cardTitle: string;

	@IsArray()
	@IsString({ each: true })
	@ArrayMinSize(1)
	bullets: string[];
}

export class CreateProductUpdatePopupDto {
	@IsString()
	title: string;

	@IsString()
	badgeText: string;

	@IsDate()
	@Type(() => Date)
	date: Date;

	@IsBoolean()
	isMobile: boolean;

	@IsBoolean()
	isDesktop: boolean;

	@IsOptional()
	@IsDate()
	@Type(() => Date)
	scheduledDate: Date;

	@IsArray()
	@ValidateNested({ each: true })
	@ArrayMinSize(1)
	@Type(() => CreatePopUpSectionDto)
	sections: CreatePopUpSectionDto[];
}

export class ProductUpdatePopupDto {
	id: string;
	title: string;
	badgeText: string;
	date: Date;
	isMobile: boolean;
	isDesktop: boolean;
	scheduledDate: Date | null;
	sections: object[];
	createdDate: Date;
}

export class UpdatePopUpSectionDto extends CreatePopUpSectionDto {
	@IsUUID()
	id: string;
}
